import { FieldsAPI, ResourceDetail } from '@cibo/core'
import { useAuth } from '@cibo/profile'
import { useQueryClient } from '@tanstack/react-query'
import { propEq } from 'ramda'
import { v4 as uuid } from 'uuid'
import { QUERY_KEY } from '../queries'
import { randomTillableParcelGeometry } from './randomTillableParcelGeometry'

export const useGenerateTestField = () => {
  const { username } = useAuth()
  const queryClient = useQueryClient()

  return {
    generateTestField: async (details: ResourceDetail[] = [], { labels }: { labels: string[] }) => {
      if (!details.find(propEq('traitId', 'geometry'))) {
        const geometry = await randomTillableParcelGeometry()

        details.push({
          traitId: 'geometry',
          input: {
            feature: {
              type: 'Feature',
              geometry,
            },
          },
        })

        // enable demeter to generate control groups
        details.push({
          input: { plantedAt: null, harvestedAt: null, crop: 'corn' },
          traitId: 'cashCrop',
          year: 2024,
        })
      }

      if (!details.find(propEq('traitId', 'name'))) {
        const name = `${username} TEST ${uuid().substring(0, 7).toUpperCase()}`

        details.push({
          traitId: 'name',
          input: { name },
        })
      }

      return FieldsAPI.create({
        metadata: { labels },
        details,
      }).then(() => {
        queryClient.invalidateQueries([QUERY_KEY.FIELDS_PAGINATED])
      })
    },
  }
}
